export const MARK_SHIPPED_REQUEST = 'MARK_SHIPPED_REQUEST';
export const markShipped = (payload) => ({
  type: MARK_SHIPPED_REQUEST,
  payload,
});

export const MARK_SHIPPED_SUCCESS = 'MARK_SHIPPED_SUCCESS';
export const markShippedSuccess = (response, fulfillmentPlanIds) => ({
  type: MARK_SHIPPED_SUCCESS,
  response,
  fulfillmentPlanIds,
});

export const MARK_SHIPPED_FAILURE = 'MARK_SHIPPED_FAILURE';
export const markShippedFailure = (error) => ({
  type: MARK_SHIPPED_FAILURE,
  error,
});

export const MARK_SHIPPED_PUSHER_MESSAGE = 'MARK_SHIPPED_PUSHER_MESSAGE';
export const markShippedPusherMessage = (batchId) => ({
  type: MARK_SHIPPED_PUSHER_MESSAGE,
  batchId,
});

export const UNDO_MARK_SHIPPED_REQUEST = 'UNDO_MARK_SHIPPED_REQUEST';
export const undoMarkShipped = (fulfillmentPlanIds) => ({
  type: UNDO_MARK_SHIPPED_REQUEST,
  fulfillmentPlanIds,
});

export const UNDO_MARK_AS_SHIPPED_FROM_ORDER_DETAILS = 'UNDO_MARK_AS_SHIPPED_FROM_ORDER_DETAILS';
export const undoMarkAsShippedFromOrderDetails = (fulfillmentId) => ({
  type: UNDO_MARK_AS_SHIPPED_FROM_ORDER_DETAILS,
  fulfillmentId,
});

export const UNDO_MARK_SHIPPED_SUCCESS = 'UNDO_MARK_SHIPPED_SUCCESS';
export const undoMarkShippedSuccess = (response, fulfillmentPlanIds) => ({
  type: UNDO_MARK_SHIPPED_SUCCESS,
  response,
  fulfillmentPlanIds,
});

export const SHIPMENT_DETAILS_UNDO_MARK_SHIPPED = 'SHIPMENT_DETAILS_UNDO_MARK_SHIPPED';
export const shipmentDetailsUndoMarkShipped = () => ({
  type: SHIPMENT_DETAILS_UNDO_MARK_SHIPPED,
});

export const CLEAR_BATCH_FROM_ORDERS = 'CLEAR_BATCH_FROM_ORDERS';
export const clearBatchFromOrders = (batchId) => ({
  type: CLEAR_BATCH_FROM_ORDERS,
  batchId,
});

export const CLEAR_BATCH_FROM_SHIPMENTS = 'CLEAR_BATCH_FROM_SHIPMENTS';
export const clearBatchFromShipments = (batchId) => ({
  type: CLEAR_BATCH_FROM_SHIPMENTS,
  batchId,
});
